export default function LocationsSection() {
  const handleGetDirections = () => {
    window.open('https://www.google.com/maps/search/The+Border+Burger+Co+Juarez', '_blank');
  };

  const handleCall = () => {
    window.location.href = 'tel:+526569876543';
  };

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12">
          {/* About Section */}
          <div>
            <h2 className="text-3xl font-bold mb-6">About The Border Burger Co.</h2>
            <p className="text-gray-700 mb-6 leading-relaxed">
              Gourmet burgers crafted with passion and creativity. We're not just another burger joint – we're a celebration of bold flavors, quality ingredients, and the perfect burger experience. Every patty is made from premium beef, hand-formed daily, and grilled to perfection.
            </p>
            <p className="text-gray-700 mb-6 leading-relaxed">
              From classic cheeseburgers to our signature creations topped with bacon jam, crispy onion strings, and house-made sauces, each burger tells a story. Paired with our hand-cut fries and craft beverages, this is casual dining elevated to an art form. Perfect for families, friends, and burger enthusiasts alike.
            </p>
            
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center">
                  <i className="ri-restaurant-2-line text-amber-600 text-2xl"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-lg mb-1">Signature Burgers</h3>
                  <p className="text-gray-600">Creative gourmet combinations you won't find anywhere else</p>
                </div>
              </div>
              
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center">
                  <i className="ri-knife-line text-amber-600 text-2xl"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-lg mb-1">Hand-Cut Fries</h3>
                  <p className="text-gray-600">Fresh potatoes cut daily and fried to golden perfection</p>
                </div>
              </div>
              
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center">
                  <i className="ri-group-line text-amber-600 text-2xl"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-lg mb-1">Family Friendly</h3>
                  <p className="text-gray-600">Relaxed atmosphere perfect for everyone</p>
                </div>
              </div>
            </div>
          </div>

          {/* Location Details */}
          <div>
            <div className="bg-gray-50 rounded-lg p-8 mb-6">
              <h3 className="text-2xl font-bold mb-6">Location & Hours</h3>
              
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center">
                    <i className="ri-map-pin-line text-amber-600 text-2xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold mb-1">Address</h4>
                    <p className="text-gray-700">Av. Lincoln 1234<br/>Col. Partido Romero<br/>Juárez, Chihuahua</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center">
                    <i className="ri-phone-line text-amber-600 text-2xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold mb-1">Phone</h4>
                    <a href="tel:+526569876543" className="text-amber-600 hover:underline">
                      +52 656 987 6543
                    </a>
                  </div>
                </div>
                
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center">
                    <i className="ri-time-line text-amber-600 text-2xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold mb-2">Hours</h4>
                    <div className="space-y-1 text-sm text-gray-700">
                      <p>Monday - Thursday: 11:00 AM - 10:00 PM</p>
                      <p>Friday - Saturday: 11:00 AM - 11:00 PM</p>
                      <p>Sunday: 12:00 PM - 9:00 PM</p>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="mt-8 flex gap-4">
                <button
                  onClick={handleGetDirections}
                  className="flex-1 bg-amber-600 text-white px-6 py-3 rounded-lg hover:bg-amber-700 transition-colors font-semibold whitespace-nowrap cursor-pointer"
                >
                  Get Directions
                </button>
                <button
                  onClick={handleCall}
                  className="flex-1 border-2 border-amber-600 text-amber-600 px-6 py-3 rounded-lg hover:bg-amber-50 transition-colors font-semibold whitespace-nowrap cursor-pointer"
                >
                  Call Now
                </button>
              </div>
            </div>
            
            {/* Map */}
            <div className="rounded-lg overflow-hidden h-[300px]">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3407.5!2d-106.45!3d31.74!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzHCsDQ0JzI0LjAiTiAxMDbCsDI3JzAwLjAiVw!5e0!3m2!1sen!2smx!4v1234567890"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="The Border Burger Co. Location"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
